import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GAAProjectSpaceInstalledDoorCameraMaster";
const FetchRequestType = "GAAProjectSpaceInstalledDoorCameraFetchRequest";

// Save All Data To Database //
export const SaveGAADoorCameraMaster = async (ref, payload, images) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, images);
};
// Get All Data From Database //
export const GetGAADoorCameraMasterList = async () => {
  let payload = {GAAProjectSpaceInstalledDoorCameraRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

// Get Single Data From Database //
export const GetGAADoorCameraMaster = async (Ref) => {
  let payload = {GAAProjectSpaceInstalledDoorCameraRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const DeleteGAADoorCameraMaster = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};


export const GetGAADoorCameraMasterListByArea = async (Ref) => {
  let payload = { GAAProjectSpaceTypeAreaRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
};

export const GetGAADoorCameraMasterListBySpace = async (Ref) => {
  let payload = { GAAProjectSpaceRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
};
